module.exports = __webpack_public_path__ + "img/aprueba.c37cdefe.png";